import React from "react";

import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NuDropdown from "components/nubox/NuDropdown";
import ImageUploadSingle from "components/nubox/ImageUploadSingle"; 
import NuCheckbox from "components/nubox/NuCheckbox"

import NuConfirm from "components/nubox/Box/NuConfirm";
import NuLoading from 'components/nubox/NuLoading';



import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const initialForm={
  idglo:1,

  e_nom: '',
  e_dir: '',
  e_logo:'',
  e_logo_horiz:'',
  e_tel: '', 
  e_email: '',
  e_ciudad: '',
  rep_logo:'',
  rep_leyenda:'',
  b1_fechaf:'',
  b2_fechaf:'',
  b3_fechaf:'',
  b4_fechaf:'',
}

/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class Globalx extends React.Component {  

  modalRef = React.createRef();//create ref
  
  state = {
    isLoading: false,
    modalInsertar: false,
    form: initialForm,
    data: [],/* lista  */
    
  };
  
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});

    const date = new Date();
    const fecha_now = date.toLocaleDateString('en-CA');
  
    //this.setState({fechai: defaultValue}); 
    this.setState({ form:{...this.state.form, 
      b1_fechaf: fecha_now,
      b2_fechaf: fecha_now,
      b3_fechaf: fecha_now,
      b4_fechaf: fecha_now,
    }}); 

    this.cargar_globalx();
    
    //this.cargar_citas();
    //this.fetchData(this.state.fechai);
    console.log(this.modalRef);
  }

  //------------ cambiamos la fecha
  /*handleChange = event =>{
    this.setState({ name: event.target.value});
  }*/
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;              
      //------------------------------------------------

      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
      

    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //====================================================== 
  //----cargamos los datos desde la base de datos
  /*{
    "id_medico": 1,
        "nombre": "Dr. Gerson Abner Villafuerte Oporto",
        "dir": "",
        "tel": "",
        "cel": "",
        "foto_path1": ""
        "especialidad": "Ortodoncia"
  },*/
  cargar_globalx = () => {
    let param = { 
      
    }
    
    axios2.post(process.env.REACT_APP_API_URL  + "globalx_get_global", param)
    .then(res => {
      //console.log(res.data);

        if(res.data !== null ){ 
            //NotificationManager.success("Correcto");
            this.setState({form: res.data});
            //console.log(this.state.medicos);
        }else{
            this.setState({form: initialForm});
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
      
  imprimir =(id_certi)=>{
    let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //----------------
  
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_globalx();
  }
  /************************************************ */
  okImage = (filename) =>{    
    this.setState({ form:{...this.state.form, e_logo: filename}}); 
  }
  cancelImage = () =>{
    //---ocultamos la ventana
    this.setState({ form:{...this.state.form, e_logo: '' }}); 
  }
  /***************************************************** */
  okImage1 = (filename) =>{    
    this.setState({ form:{...this.state.form, rep_logo: filename}}); 
  }
  cancelImage1 = () =>{
    //---ocultamos la ventana
    this.setState({ form:{...this.state.form, rep_logo: '' }}); 
  }

  /***************************************************** */
  okImageP = (filename) =>{    
    this.setState({ form:{...this.state.form, e_logo_horiz: filename}}); 
  }
  cancelImageP = () =>{
    //---ocultamos la ventana
    this.setState({ form:{...this.state.form, e_logo_horiz: '' }}); 
  }
  //----------------------------------------
  save =() =>{
  
    //let param =  {};
    let param =  this.state.form;
    param.idd =1;
    param.ope ='e';
    console.log(param);

    this.setState({ isLoading:true })
    axios2.post(process.env.REACT_APP_API_URL  + "globalx_store", param)
    .then(res => {
        this.setState({ isLoading:false })
        if(res.data.exito === 1){ 
            toast.success(res.data.mensaje);
        }else{
            toast.error(res.data.mensaje);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  
  }
  //-------------------------------------
  render() {
    
    return (
      <div>
        
        <div className="content">
          {
            //JSON.stringify( this.state.form )
          }
          {/*<!--- ------------------------------->*/}
          <div className="row justify-content-center">
            <div className="col-md-11">

              {/*<!-- -->*/}
              <div className="card">
                <div class="card-header" style={{backgroundColor: 'antiquewhite' }}>
                  <h4>Configuración global</h4>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-hover " style={{ backgroundColor: "#fff", border: "1px solid #d2d2d2" }} >
                    <tbody>

                      <tr>
                        <td className=" text-right" width="30%"><strong>Nombre:</strong></td>
                        <td width="30%">
                          <input
                            name="e_nom"
                            type="text"
                            onChange={this.handleChangeForm}
                            value={this.state.form.e_nom}
                            size="25" />
                        </td>
                        <td className=" text-right" width="40%">
                          <div className="notecafe info">Nombre de la institución</div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Direccion:</strong></td>
                        <td>
                          <input
                            name="e_dir"
                            type="text"
                            className=""
                            onChange={this.handleChangeForm}
                            value={this.state.form.e_dir}
                            size="25" />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Direccion </div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Logo:</strong></td>
                        <td>
                          <ImageUploadSingle  
                            okImage={ this.okImage}
                            cancelImage={ this.cancelImage}
                            imageURL={process.env.REACT_APP_AFILES}
                            fileName={this.state.form.e_logo}
                          />

                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Imagen representativa de la institución</div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Telefono:</strong></td>
                        <td>
                          <input
                            name="e_tel"
                            type="text"
                            className=""
                            onChange={this.handleChangeForm}
                            value={this.state.form.e_tel}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Nro de teléfono</div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><b>Email:</b></td>
                        <td>
                          <input
                            name="e_email"
                            type="text"
                            className=""
                            onChange={this.handleChangeForm}
                            value={this.state.form.e_email}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Correo electrónico</div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><b>Logo horizontal:</b></td>
                        <td>
                          <ImageUploadSingle  
                            okImage={ this.okImageP}
                            cancelImage={ this.cancelImageP}
                            imageURL={process.env.REACT_APP_AFILES}
                            fileName={this.state.form.e_logo_horiz}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Logo que se muestra en la pagina de login</div>
                        </td>
                      </tr>
                      {/*  Resoluciones */}
                      <tr>
                        <td colSpan="3" className="separador_cafe1"><strong>Resoluciones:</strong></td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>R.M. 1:</strong></td>
                        <td>
                          <input type="text"
                            className="form-control input-sm"
                            name="rm1"
                            value={this.state.form.rm1}
                            onChange={this.handleChangeForm}
                            required={true}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Resolucion ministerial
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className=" text-right"><strong>R.M. 2:</strong></td>
                        <td>
                          <input type="text"
                            className="form-control input-sm"
                            name="rm2"
                            value={this.state.form.rm2}
                            onChange={this.handleChangeForm}
                            required={true}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Fecha maxima que estará habilitado para llenar notas
                          </div>
                        </td>
                      </tr>

                       {/*  Resoluciones */}
                       <tr>
                        <td colSpan="3" className="separador_cafe1"><strong>Botones:</strong></td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Preinscripción:</strong></td>
                        <td>
                          <NuCheckbox
                            label=""
                            name="btn_preins_sn"
                            value={this.state.form.btn_preins_sn}
                            onChange={ this.handleChangeForm }

                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Habilita el boton de preinscripcion en lapagina principal
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className=" text-right"><strong>Registro de asistencia:</strong></td>
                        <td>
                          
                          <NuCheckbox
                            label=""
                            name="btn_asis_sn"
                            value={this.state.form.btn_asis_sn}
                            onChange={ this.handleChangeForm }

                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Habilita el boton de registro de asistencia
                          </div>
                        </td>
                      </tr>


                       {/*  Resoluciones */}
                       <tr>
                        <td colSpan="3" className="separador_cafe1"><strong>Reportes:</strong></td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Encabezado:</strong></td>
                        <td>
                          <ImageUploadSingle  
                            okImage={ this.okImage1}
                            cancelImage={ this.cancelImage1}
                            imageURL={process.env.REACT_APP_AFILES}
                            fileName={this.state.form.rep_logo}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className=" text-right"><strong>Leyenda:</strong></td>
                        <td>
                          <input type="text"
                            className="form-control input-sm"
                            name="rep_leyenda"
                            value={this.state.form.rep_leyenda}
                            onChange={this.handleChangeForm}
                            required={true}
                          />
                          
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Habilita el boton de registro de asistencia
                          </div>
                        </td>
                      </tr>

                      {/*  Habilitacion de fechas */}
                      <tr>
                        <td colSpan="3" className="separador_cafe1"><strong>Habilitación:</strong></td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Bimestre 1:</strong></td>
                        <td>
                          <input type="date"
                            className="form-control input-sm"
                            name="b1_fechaf"
                            value={this.state.form.b1_fechaf}
                            onChange={this.handleChangeForm}
                            required={true}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Fecha maxima que estará habilitado para llenar notas
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Bimestre 2:</strong></td>
                        <td>
                          <input type="date"
                            className="form-control input-sm"
                            name="b2_fechaf"
                            value={this.state.form.b2_fechaf}
                            onChange={this.handleChangeForm}
                            required={true}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Fecha maxima que estará habilitado para llenar notas
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Bimestre 3:</strong></td>
                        <td>
                          <input type="date"
                            className="form-control input-sm"
                            name="b3_fechaf"
                            value={this.state.form.b3_fechaf}
                            onChange={this.handleChangeForm}
                            required={true}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Fecha maxima que estará habilitado para llenar notas
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td className=" text-right"><strong>Bimestre 4:</strong></td>
                        <td>
                          <input type="date"
                            className="form-control input-sm"
                            name="b4_fechaf"
                            value={this.state.form.b4_fechaf}
                            onChange={this.handleChangeForm}
                            required={true}
                          />
                        </td>
                        <td className=" text-right">
                          <div className="notecafe info">Fecha maxima que estará habilitado para llenar notas  
                            
                          </div>
                        </td>
                      </tr>


                      <tr>
                        <td className="" colSpan="3" align="center">
                        <Button onClick={ this.save } className="btn btn-success">
                            <i className="fa fa-floppy-o"></i>&nbsp;
                            Guardar Datos
                        </Button>
                        
                        <button className="btn btn-default" >Cancelar</button>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="3">
                        <NuLoading text="Cargando...." show= { this.state.isLoaging }/>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/*<!-- -------------------------------------------------->*/}

        </div>

        <ToastContainer />
      </div>
    );
  }
}
  
export default Globalx;